import type { CustomerReservationDetails } from '@iheartjane/data-access';
import { getReservationModeLabel } from '@iheartjane/menu';
import { Flex, Link, Typography } from '@iheartjane/reefer';
import { sentenceCase } from '@iheartjane/utils';
import { useMemo } from 'react';

// eslint-disable-next-line no-restricted-imports
import type { Store } from '@jane/shared/models';

import { ReservationTime } from './ReservationTime';
import { StoreSchedule } from './StoreSchedule';

interface OrderDetailsProps {
  cart: CustomerReservationDetails;
  store: Store;
}

export const OrderDetails = ({ cart, store }: OrderDetailsProps) => {
  const reservationModeSentence = useMemo(() => {
    if (cart) {
      return sentenceCase(
        getReservationModeLabel(
          cart.reservation_mode,
          cart.store.reservation_mode_labels
        )
      );
    }
    return '';
  }, [cart]);

  return (
    <>
      <Flex flexDirection="column">
        <Typography variant="body-semibold">Store information</Typography>
        <Typography>{store.name}</Typography>
        <Typography>{store.address}</Typography>
        <Typography>
          {store.city}, {store.state}
        </Typography>
        <Typography>{store.zip}</Typography>
      </Flex>
      <Flex flexDirection="column" mt={20}>
        <Link href={`tel:${store.phone}`}>
          <Typography>{store.phone}</Typography>
        </Link>
        {cart.reservation_mode !== 'delivery' && (
          <Link
            href={`https://www.google.com/maps?daddr=${cart.store.lat},${cart.store.long}`}
            color="text-main"
          >
            Get directions
          </Link>
        )}
        <StoreSchedule reservation={cart} />
      </Flex>
      <Flex flexDirection="column" mt={20}>
        {cart.reservation_mode !== 'kiosk' && (
          <>
            <Typography variant="body-semibold" color="text-main">
              {reservationModeSentence} time
            </Typography>
            <Typography color="text-main">
              <ReservationTime reservation={cart} />
            </Typography>
          </>
        )}
        {cart.address && (
          <>
            <Typography variant="body-semibold" color="text-main" mt={24}>
              Delivery address
            </Typography>
            <Typography whiteSpace="pre">{cart.address}</Typography>
          </>
        )}
      </Flex>
    </>
  );
};
